import React from "react";

/**
 * MAX Fitness brand logo.
 * Uses /max-fitness-logo.svg from public/. Auto-inverts in dark theme.
 */
const Logo = ({ className = "h-8 sm:h-9 w-auto", ariaLabel = "MAX Fitness" }) => (
  <img
    src="/max-fitness-logo.svg"
    alt={ariaLabel}
    width="256"
    height="76"
    className={`logo-adapt ${className}`}
    data-invert="dark"
    draggable={false}
  />
);

export default Logo;
